import { bus } from "@/main.js";

export default {
	name: "App",
	data() {
		return {
			hideContent: false,
			black: false,
			url: null,
		}
	},
	created() {
		bus.$on("currentOpen", () => {
			this.hideContent = true;
		})
	},
	computed: {
		getCurrentUrl: function() {
			return location.href;
		}
	},
	watch: {
		"$route": function() {
			this.hideContent = false;
		}
	},
	methods: {
		revertColor() {
			this.black = !this.black
		}
	}
}



// WEBPACK FOOTER //
// ./src/App.js